<template>
  <div class="don-form" ref="donForm">
    <v-sheet class="mx-auto" :max-width="600">
      <template v-if="paymentProcessing">
        <p class="text-center">Nous traitons votre demande...</p>
        <p class="text-center">
          <v-progress-circular indeterminate :size="50"></v-progress-circular>
        </p>
      </template>
      <template v-else>
        <h3 class="mb-6 text-uppercase">
          Faire un don en ligne
          <img class="d-inline ml-3" src="@/assets/icons/lock.png" height="22" width="20" />
        </h3>

        <montant-selection v-show="currentStep === 0"></montant-selection>
        <coordonnees v-show="currentStep === 1" ref="contactForm" :key="String(currentStep === 1)"></coordonnees>
        <p v-if="message">{{ message }}</p>
        <form-controls class="my-8" :hideBack="currentStep === 0" @next="next" @back="back" :loading="loading"></form-controls>
        <v-progress-linear class="my-8" :value="((currentStep + 1) / (steps.length + 1)) * 100" color="black" height="1"></v-progress-linear>
        <div v-show="currentStep > 0" class="text-left mt-3">
          <v-btn @click="back" text> <v-icon class="mr-2">mdi-arrow-left</v-icon>Retour </v-btn>
        </div>
      </template>
    </v-sheet>
    <div id="recaptcha"></div>
  </div>
</template>

<script>
import MontantSelection from "@/components/donate/montantSelection"
import Coordonnees from "@/components/donate/coordonees"
import FormControls from "@/components/forms/controls"
import { mapActions, mapGetters, mapMutations } from "vuex"
export default {
  data() {
    return {
      steps: ["Montant", "Coordonnées"],
      currentStep: 0,
      loading: false,
      paymentProcessing: false,
      paysafe: null,
      grecaptcha: null,
      message: ""
    }
  },
  created() {
    if (this.$route.query.type) {
      var type = this.$route.query.type == 1 ? 1 : 0
      this.$store.commit("setTypeDeDon", type)
    }
    this.$loadScript(process.env.VUE_APP_GOOGLE_RECAPTCHA_SDK).then(() => {
      this.loadGrecaptcha()
      this.renderCaptcha()
    })
    this.$loadScript(process.env.VUE_APP_PAYSAFE_SDK).then(() => {
      this.paysafe = window.paysafe
    })
  },
  watch: {
    montantDon() {
      this.message = ""
    }
  },
  computed: {
    ...mapGetters({
      montantDon: "getMontantDon",
      holderName: "getHolderName",
      contact: "getContact",
      typeDeDon: "getTypeDeDon",
      isCanada: "isCanada",
      paramsFormulaire: "getParamsFormulaire",
      montantsSimplesPossibles: "getMontantsUniquesPossibles",
      montantsMensuelsPossibles: "getMontantsMensuelsPossibles"
    }),
    isIFrame() {
      return this.$route.fullPath.includes("iframe")
    }
  },
  components: {
    MontantSelection,
    Coordonnees,
    FormControls
  },
  methods: {
    ...mapMutations(["setPaymentToken", "setPaymentMethod"]),
    ...mapActions(["createSasDeDon"]),
    renderCaptcha() {
      if (this.grecaptcha && this.grecaptcha.render) {
        this.grecaptcha.render("recaptcha", {
          sitekey: process.env.VUE_APP_GOOGLE_RECAPTCHA_APIKEY,
          callback: this.showPaysafe,
          size: "invisible"
        })
        this.grecaptcha.reset()
      } else {
        // reCaptcha not loaded yet, trying again in 500ms
        setTimeout(this.renderCaptcha, 500)
      }
    },
    loadGrecaptcha() {
      if (window.grecaptcha.render) {
        this.grecaptcha = window.grecaptcha
      } else {
        // reCaptcha not loaded yet, trying again in 500ms
        setTimeout(this.loadGrecaptcha, 500)
      }
    },
    getOptionsPaysafe() {
      var baseOptions = {
        amount: parseInt(this.montantDon * 100),
        currency: "CAD",
        companyName: "Amnistie internationale",
        environment: process.env.VUE_APP_ENVIRONEMENT_PAYSAFE,
        holderName: this.holderName,
        imageUrl: "https://amnistie.ca/dons/img/logo-footer.jpg",
        locale: "fr_CA",
        buttonLabel: "Oui, je donne"
      }
      if (this.isCanada) {
        return {
          ...baseOptions,
          billingAddress: {
            country: "CA",
            zip: this.contact.codePostal,
            city: this.contact.ville,
            street: this.contact.adresse
          }
        }
      } else {
        return baseOptions
      }
    },
    onSubmitPaysafe(instance, error, result) {
      this.paymentProcessing = true
      this.setPaymentToken(result.token)
      this.setPaymentMethod(result.paymentMethod)
      this.createSasDeDon()
        .then((res) => {
          if (res.data.paiementRejete) {
            this.$router.push({
              name: this.getRouteName("Erreur"),
              params: { ...res.data }
            })
          } else {
            this.googleAnalytics(res.data)

            this.$router.push({
              name: this.getRouteName("Merci"),
              params: { sasDeDonId: res.data.id, sasDeDon: res.data }
            })
          }
        })
        .catch(() => {
          this.$router.push({
            name: this.getRouteName("Erreur")
          })
        })
        .then(() => {
          instance.close()
          //this.loading=false
          //this.paymentProcessing = false
        })
    },
    onClosePaysafe(stage) {
      this.loading = false
      this.paymentProcessing = false
      this.grecaptcha.reset()
      if (stage === "BeforePayment") {
        // No payment have been made
      } else if (stage === "DuringPayment") {
        // Token have been issued, but the checkout overlay was closed from the user before instance flow control method was invoked
      } else if (stage === "AfterPayment") {
        // Closed either via instance.close method or by the user from the success screen
      }
    },
    showPaysafe() {
      this.loading = true
      this.$vuetify.goTo(0)
      this.paymentProcessing = true
      this.paysafe.checkout.setup(process.env.VUE_APP_PAYSAFE_APIKEY, this.getOptionsPaysafe(), this.onSubmitPaysafe, this.onClosePaysafe)
    },
    next() {
      if (this.currentStep === 0) {
        if (parseFloat(this.montantDon)) {
          this.currentStep++
          this.message = ""
        } else {
          this.message = "Veuillez entrer un montant"
        }
      } else if (this.currentStep === 1) {
        if (this.$refs.contactForm.validate()) {
          this.grecaptcha.execute()
        }
      }
    },
    back() {
      this.currentStep--
    },
    getSku(montant) {
      if (this.typeDeDon == 0) {
        if (this.montantsSimplesPossibles.find((m) => m.v == montant)) {
          return "DU" + montant
        }
        return "DUCUSTOM"
      } else if (this.typeDeDon == 1) {
        if (this.montantsMensuelsPossibles.find((m) => m.v == montant)) {
          return "DM" + montant
        }
        return "DMCUSTOM"
      }
    },
    getRouteName(baseRoute) {
      return baseRoute + (this.isIFrame ? "IFrame" : "")
    },
    googleAnalytics({ donDTO, id, nomCampagne }) {
      const affiliation = "Formulaire de don"
      const category = donDTO.typeDeDon.toUpperCase()
      const amount = donDTO.montantMultipliePar100 / 100
      const sku = this.getSku(amount)

      window.gtag("event", "purchase", {
        transaction_id: id,
        affiliation: affiliation,
        value: amount,
        items: [
          {
            item_id: sku,
            item_name: nomCampagne,
            currency: "CND",
            index: 0,
            item_category: category,
            price: amount,
            quantity: 1
          }
        ]
      })

      const gtagObject = {
        event: "ecommerce",
        transactionId: id,
        transactionAffiliation: affiliation,
        transactionTotal: amount,
        transactionProducts: [
          {
            sku: sku,
            name: nomCampagne,
            category: category,
            price: amount,
            quantity: 1
          }
        ]
      }
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(gtagObject)
    }
  }
}
</script>

<style scoped lang="scss">
</style>